<template>
  <div class="w-full">
    <InputText
      v-if="type == 'text'"
      class="w-full"
      :error="localAttribute?.error || undefined"
      :model-value="localAttribute?.value"
      @update:model-value="(val) => emit('emitValue', val)"
    />
    <InputNumber
      v-if="type == 'number'"
      class="w-full"
      :error="localAttribute?.error || undefined"
      :model-value="localAttribute?.value as number | undefined"
      @update:model-value="(val) => emit('emitValue', val)"
    />
    <InputTextarea
      v-if="type == 'textarea'"
      :error="localAttribute?.error || undefined"
      :model-value="localAttribute?.value"
      @update:model-value="(val) => emit('emitValue', val)"
    />
    <FileUpload
      v-if="type == 'file' || type == 'dor' || type == 'file_with_pdf'"
      :error="localAttribute?.error || undefined"
      :model-value="localAttribute?.value"
      :index="index"
      :shipment-id="shipmentId"
      s3
      :message="t('pdf_size')"
      @update:model-value="(val) => emit('emitValue', val)"
    />
    <FileUpload
      v-if="type == 'file[]'"
      :error="localAttribute?.error || undefined"
      :model-value="localAttribute?.value"
      :index="index"
      image-preview
      multiple
      :shipment-id="shipmentId"
      s3
      @update:model-value="(val) => emit('emitValue', val)"
    />
    <Dropdown
      v-if="type == 'select'"
      v-model="localAttribute!.value"
      class="w-full"
      :error="localAttribute?.error || undefined"
      :options="localAttribute?.options ?? []"
      :placeholder="t('select')"
      @update:model-value="(val) => emit('emitValue', val)"
    />
    <TickerCheckbox
      v-if="type == 'boolean'"
      v-model="localAttribute!.value"
      class="mt-1"
      :error="Boolean(localAttribute?.error)"
      @update:model-value="(val) => emit('emitValue', val)"
      >{{ localAttribute?.value ? t("yes") : t("no") }}</TickerCheckbox
    >
  </div>
</template>

<script setup lang="ts">
  import type { AttributeWithError } from "~/types/ticket";

  const { t } = useI18n();

  const emit = defineEmits(["emitValue"]);

  const props = defineProps<{
    type: string;
    name?: string;
    shipmentId: string;
    index: number;
    attribute: AttributeWithError;
  }>();

  const attribute = computed(() => props.attribute);

  const localAttribute = ref<AttributeWithError>();

  watch(
    attribute,
    (attr) => {
      localAttribute.value = { ...attr };
    },
    { immediate: true, deep: true }
  );
</script>
